import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { heading4Obj } = typographyStyles;
const { colors } = constants;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const darkGrey = colors.brand.neutral[700];
const yellow = colors.ui.yellow[500];

export const containerCss = {
  display: "flex",
  minHeight: "88px",
  background: yellow,
};

export const iconCss = {
  minWidth: "40px",
  height: "40px",
  margin: "18px 0px 30px 16px",
  path: {
    fill: darkGrey,
  },
  "path:nth-child(2)": {
    stroke: darkGrey,
    filter: "drop-shadow(1px -1px 0px rgb(29 29 29 / 0.25))",
  },
  "path:nth-child(3)": {
    stroke: yellow,
  },
  [breakpoint.upTo("xs")]: {
    display: "none",
  },
};

export const headingCss = {
  ...heading4Obj,
  marginBlockEnd: "0.3em",
  marginBlockStart: "0.7em",
  marginLeft: "16px",
};

export const textBodyCss = {
  marginBottom: "16px",
  marginLeft: "16px",
  marginRight: "16px",
};
